export const Filters = {
    DEPARTMENTS: 'departments',
    EMPLOYEE_LEVELS: 'employeeLevels',
    JOB_TITLES: 'jobTitles',
    COMPANY_ADDRESSES: 'companyAddresses',
    MANAGERS: 'managers',
} as const;

/**
 * The attribute families a `SelectedFilters` keeps a bucket of their own for. Every other family
 * pours its values into `customAttributes`: the custom attributes, and the age groups and tenures,
 * which `useCompanyAttributesFilters` files there too.
 */
export const ATTRIBUTE_FAMILIES_WITH_OWN_BUCKET: readonly string[] = Object.values(Filters);

/** Every bucket of a `SelectedFilters`, the shared `customAttributes` one last. */
export const ATTRIBUTE_BUCKETS: readonly string[] = [
    ...ATTRIBUTE_FAMILIES_WITH_OWN_BUCKET,
    'customAttributes',
];

export const CompetencyGroupsFilters = {
    ALL: 'all',
    ACTIVE: 'active',
    INACTIVE: 'inactive',
} as const;
